import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Fab from "@material-ui/core/Fab";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import TestimonialCard from "../cards/TestimonialCard";
import useSliderNavigation from "../hooks/useSliderNavigation";
import { gql } from "@apollo/client";

const useStyles = makeStyles((theme) => ({
  root: {
    // backgroundColor: theme.palette.background.default,
  },
  slider: {
    "& .slick-center .testmonial-message": {
      borderRadius: "50px 0px",
      [theme.breakpoints.up("md")]: {
        transform: "scale(1.14)",
      },
    },
  },
  nextButton: {
    position: "absolute",
    bottom: 0,
    left: "50%",
    transform: "translate(-50%,0%)",
    width: 60,
    height: 60,
    [theme.breakpoints.up("md")]: {
      transform: "translate(-50%,45%)",
    },
  },
}));

const TestimonialSlider = ({ content }: TestimonialSliderdProps) => {
  const classes = useStyles();
  const { sliderRef, next } = useSliderNavigation();

  const settings = {
    className: classes.slider,
    centerMode: true,
    infinite: true,
    centerPadding: "0px",
    slidesToShow: 3,
    speed: 500,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 1170,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <Box className={classes.root} paddingY={[2, 4, 6, 8]}>
      <Container>
        {content.testimonials ? (
          <Typography
            variant="h1"
            component="h3"
            gutterBottom
            style={{ fontWeight: 400 }}
            paragraph
          >
            {content.heading ? content.heading : "Client Testimonials"}
          </Typography>
        ) : (
          ""
        )}
        {content.testimonials ? (
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Box position="relative">
                <Slider {...settings} ref={sliderRef}>
                  {content.testimonials.map((testimonial, index) => (
                    <TestimonialCard
                      key={testimonial.userName.toLocaleLowerCase() + index}
                      userName={testimonial.userName}
                      comments={testimonial.comments}
                      userJobTitle={testimonial.userJobTitle}
                      imageUrl={testimonial.imageUrl}
                    />
                  ))}
                </Slider>

                <Fab
                  color="primary"
                  className={classes.nextButton}
                  aria-label="next"
                  onClick={next}
                >
                  <KeyboardBackspaceIcon
                    style={{
                      transform: "rotate(180deg)",
                    }}
                  />
                </Fab>
              </Box>
            </Grid>
          </Grid>
        ) : (
          ""
        )}
      </Container>
    </Box>
  );
};

TestimonialSlider.fragments = {
  testimonials: gql`
    fragment TestmonialSliderFragment on Testimonial {
      userName
      imageUrl
      userJobTitle
      comments
      userCompanyName
      userFiveStarRating
    }
  `,
};

export default TestimonialSlider;
